<template>
    <console-layout v-if="ready" width="100%" max-width="1024">

        <console-title>
            <span v-if="member._id">회원상세</span>
            <span v-else>회원등록</span>
        </console-title>

        <console-body>
            <v-row>
                <v-col cols="12" md="8" class="pr-md-1">
                    <v-card class="mx-1">
                        <v-card-title class="subtitle-2 font-weight-bold">기본정보</v-card-title>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.username" label="아이디" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-password-field v-model="member.password" label="비밀번호" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.name" label="이름" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.code" label="추천인코드" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.phone" label="연락처" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.email" label="이메일" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.postcode" label="우편번호" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" class="mx-1 mt-4"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.address1" label="기본주소" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" class="mx-1 mt-4"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="member.address2" label="상세주소" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-select v-model="member.levelCode" :disabled="!$hasScope(['root', 'admin'])" :items="levels" item-text="name" item-value="code" label="회원등급" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select v-model="member.riskManagement.giftcard.level" :disabled="!$hasScope(['root', 'admin'])" :items="riskManagement.giftcard.levels" item-text="text" item-value="value" label="교환소등급" persistent-placeholder hide-details class="mx-1 mt-4"/>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-text-field v-model="member.ci" label="CI 값" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details class="mx-1 mt-4"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
    
                <v-col cols="12" md="4" class="pl-md-1">
    
                    <v-card class="mx-1 mt-3 mt-md-0">
                        <v-card-title>
                            <span class="subtitle-2">로그인 실패횟수 ({{ member.loginFailedCount[$dayjs().format("YYYY-MM-DD")] || 0 }}/5)</span>
                            <v-spacer/>
                            <v-icon :disabled="!$hasScope(['root', 'admin'])" size="20" @click="member.loginFailedCount = new Map()">mdi-refresh</v-icon>
                        </v-card-title>
                    </v-card>
    
                    <v-card class="mx-1 mt-4">
                        <v-card-title>
                            <span class="subtitle-2">자동차단여부 (차단안함/차단)</span>
                            <v-spacer/>
                            <v-switch v-model="member.isAutoBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                        </v-card-title>
                    </v-card>
                    <v-card class="mx-1 mt-4">
                        <v-card-title>
                            <span class="subtitle-2">관리자차단여부 (차단안함/차단)</span>
                            <v-spacer/>
                            <v-switch v-model="member.isBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                        </v-card-title>
                    </v-card>
                    <v-card class="mx-1 mt-2">
                        <v-card-title>
                            <span class="subtitle-2">휴면여부 (휴면안함/휴면)</span>
                            <v-spacer/>
                            <v-switch v-model="member.isDormancy" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                        </v-card-title>
                    </v-card>
    
                    <v-card class="mx-1 mt-4">
                        <v-card-title>
                            <span class="subtitle-2">SMS 수신여부 (수신안함/수신)</span>
                            <v-spacer/>
                            <v-switch v-model="member.smsEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                        </v-card-title>
                    </v-card>
                    <v-card class="mx-1 mt-2">
                        <v-card-title>
                            <span class="subtitle-2">Email 수신여부 (수신안함/수신)</span>
                            <v-spacer/>
                            <v-switch v-model="member.emailEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
    
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">관리자 메모</v-card-title>
                <v-card-text>
                    <v-textarea v-model="member.note" :disabled="!$hasScope(['root', 'admin'])" outlined hide-details rows="2" />
                </v-card-text>
            </v-card>
    
            <purchase-list />

        </console-body>

        <v-row class="my-4">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { member.postcode = postcode; member.address1 = address; }" />

    </console-layout>
</template>

<script>
import api from "@/api";
import { mdiRefresh } from "@mdi/js";
import CryptoAES from "@/plugins/crypto-aes";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import PurchaseList from "@/components/console/user/purchase-list.vue";

export default {
    components: {
        NaverSmarteditor,
        VPasswordField,
        DaumPostcode,
        PurchaseList
    },
    data(){
        return {
            mdiRefresh,

            ready: false,

            member: {
                _id: this.$route.params._member
            },

            levels: [],

            riskManagement: {
                giftcard: {
                    levels: [
                        { text: "일반등급", value: "normal" },
                        { text: "vip", value: "vip" },
                        { text: "vvip", value: "vvip" },
                    ]
                }
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { levels } = await api.console.member.levels.gets();
            this.levels = levels;

            if(this.member._id){
                let { member } = await api.console.members.get(this.member);
                this.member = member;
            }

            this.ready = true;
        },
        async save(){
            this.member._id ? await api.console.members.put({
                ...this.member,
                password: this.member.password ? CryptoAES.encrypt(this.member.password) : undefined
            }) : await api.console.members.post({
                ...this.member,
                password: this.member.password ? CryptoAES.encrypt(this.member.password) : undefined
            });
            alert("저장되었습니다");
            this.$router.go(-1);
        }
    }
}
</script>